import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { UUID } from '../../react/types';
import { MembershipInformation } from '../types/memberships';

@Injectable({
  providedIn: 'root',
})
export class NiceMembershipService {
  constructor(public httpClient: HttpClient) {}

  public getMembership(userId: UUID): Observable<MembershipInformation> {
    const queryParams = new HttpParams({
      fromObject: {
        // We should send query parameters as an array here, but this does not work when targeting localhost
        // servers for some reason. The Axios default was updated to send multiple parameters of 'type' instead.
        userId: userId,
      },
    });

    return this.httpClient
      .get<MembershipInformation>(`${environment.niceServiceUrl}/v1/membership`, {
        params: queryParams,
      })
      .pipe(
        take(1),
        map((response: any) => {
          return response;
        })
      );
  }
}
